import { useContext } from 'react';
import { ObjectScreenContext, ObjectScreenContextValue } from '../contexts/ObjectScreen.context';

export function useObjectContext(): ObjectScreenContextValue {
  const context = useContext(ObjectScreenContext);

  if (!context) {
    throw new Error('useObjectContext must be used within an <ObjectScreen>.');
  }

  return context;
}
